import requestApi from "../common/boxp_api_client"
import requestrApi from "../common/boxr_api_client"



function uploadGeneralFiles(formData) {
    return requestrApi({
        url: '/user_compliances/upload_general_file',
        method: 'POST',
        data: formData
    })
}
function deleteGeneralFiles(formData) {
    return requestrApi({
        url: '/user_compliances/destroy_general_file',
        method: 'DELETE',
        data: formData
    })
}
function updateTraining(formData) {
    return requestrApi({
        url: '/user_compliances/update_training',
        method: 'PUT',
        data: formData
    })
}
function updateComplianceExpiry(formData) {
    return requestrApi({
        url: '/user_compliances/update_compliance_expiry',
        method: 'PUT',
        data: formData
    })
}
function updateRecencyExpiry(formData) {
    return requestrApi({
        url: '/user_compliances/update_recency_expiry',
        method: 'PUT',
        data: formData
    })
}
function fetchExpiry(params) {
    return requestrApi({
        url: '/user_compliances/fetch_expiry',
        method: 'GET',
        params: params
    });
}
function fetchExpirydaysAndColorcode(params) {
    return requestApi({
        url: '/get_user_compliance_status_bar',
        method: 'GET',
        params: params
    });
}
function fetchHistoryFiles(params) {
    return requestrApi({
        url: '/user_compliances/listing_training_history',
        method: 'GET',
        params: params
    });
}
function fetchOverrideHistoryFiles(params) {
    return requestrApi({
        url: 'user_compliances/listing_override_history',
        method: 'GET',
        params: params
    });
}
function fetchComplianacePdf(params) {
    return requestrApi({
        url: '/user_compliances/download_compliance_pdf',
        method: 'GET',
        params: params
    });
}

function getUserDetails(id) {
    return requestrApi({
        url: `/users/${id}`,
        method: 'GET',
    })
}
const UserServices = {
    uploadGeneralFiles, deleteGeneralFiles, updateTraining, updateComplianceExpiry, updateRecencyExpiry, fetchExpiry, fetchExpirydaysAndColorcode, fetchHistoryFiles, fetchOverrideHistoryFiles, fetchComplianacePdf, getUserDetails
};

export default UserServices;